var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2942_2824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.873 0 0.5 5.373 0.5 12C0.5 18.627 5.873 24 12.5 24C19.127 24 24.5 18.627 24.5 12C24.481 5.381 19.119 0.019 12.5 0ZM19.707 7.707L10.707 16.707C10.512 16.902 10.256 17 10 17C9.744 17 9.488 16.902 9.293 16.707L5.293 12.707C4.902 12.316 4.902 11.684 5.293 11.293C5.684 10.902 6.316 10.902 6.707 11.293L10 14.586L18.293 6.293C18.684 5.902 19.316 5.902 19.707 6.293C20.098 6.684 20.098 7.316 19.707 7.707Z",
    fill: "#8DC700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2942_2824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0fec184f9c604b73178da2bb9114fab4.svg";
export { ForwardRef as ReactComponent };